import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  mblMenu: false,
  dropdown: false
};

export const counterSlice = createSlice({
  name: 'counter',
  initialState,
  reducers: {
    openMblMenu: (state) => {
      state.mblMenu = true;
    },
    closeMblMenu: (state) => {
      state.mblMenu = false;
    },

    openDropdown: (state) => {
      state.dropdown = true;
    },
    closeDropdown: (state) => {
      state.dropdown = false;
    }
  }
});

// Action creators are generated for each case reducer function
export const { openMblMenu, closeMblMenu, openDropdown, closeDropdown } =
  counterSlice.actions;

export default counterSlice.reducer;
